"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Body1", {
    enumerable: true,
    get: function() {
        return Body1;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useBody1Stylesstyles = require("./useBody1Styles.styles");
const Body1 = (0, _createPreset.createPreset)({
    useStyles: _useBody1Stylesstyles.useBody1Styles,
    className: _useBody1Stylesstyles.body1ClassNames.root,
    displayName: 'Body1'
});
